import Vue from 'vue';
import axiosErrorHandler from './axiosErrorHandler';

/* eslint-disable import/prefer-default-export */
export function error(e) {
  if (process.env.DEBUG) {
    console.error(e);
  }
  Vue.$toast.error(axiosErrorHandler(e));
}

export function warn(e) {
  if (process.env.DEBUG) {
    console.error(e);
  }
  Vue.$toast.warning(e);
}

export function clear() {
  Vue.$toast.clear();
}
